"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailProviderWebhookAcknowledgementSchema = exports.invoiceDeliveryListResponseSchema = exports.invoiceDeliverySchema = exports.createInvoiceDeliveryRequestSchema = exports.smsProviderWebhookAcknowledgementSchema = exports.communicationSettingsResponseSchema = exports.updateBusinessSmsSettingsRequestSchema = exports.businessSmsSettingsSchema = exports.communicationDeliveryCountsSchema = exports.communicationDeliveryQuerySchema = exports.communicationDeliveryListResponseSchema = exports.communicationDeliverySchema = exports.communicationDeliveryAttemptSchema = exports.updateCommunicationTemplateRequestSchema = exports.createCommunicationTemplateRequestSchema = exports.communicationTemplateListResponseSchema = exports.communicationTemplateListQuerySchema = exports.communicationTemplateSchema = exports.communicationTemplateStatusSchema = exports.communicationTemplateIdSchema = exports.communicationDeliveryChannelSchema = exports.smsRegistrationStatusSchema = exports.smsProviderModeSchema = exports.emailProviderModeSchema = exports.notificationDeliveryPurposeSchema = exports.notificationDeliveryStatusSchema = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
exports.notificationDeliveryStatusSchema = zod_1.z.enum([
    "PENDING",
    "SENT",
    "DELIVERED",
    "DELAYED",
    "BOUNCED",
    "COMPLAINED",
    "FAILED",
]);
exports.notificationDeliveryPurposeSchema = zod_1.z.enum([
    "PORTAL_INVITATION",
    "PORTAL_MAGIC_LINK",
    "TEAM_INVITATION",
    "JOB",
    "ESTIMATE",
    "INVOICE",
    "PAYMENT_RECEIPT",
    "REFUND_CONFIRMATION",
    "CONVERSATION",
]);
exports.emailProviderModeSchema = zod_1.z.enum([
    "LOCAL_CAPTURE",
    "RESEND",
    "UNAVAILABLE",
]);
exports.smsProviderModeSchema = zod_1.z.enum([
    "LOCAL_CAPTURE",
    "TWILIO",
    "UNAVAILABLE",
]);
exports.smsRegistrationStatusSchema = zod_1.z.enum([
    "NOT_STARTED",
    "PENDING",
    "APPROVED",
    "REJECTED",
]);
exports.communicationDeliveryChannelSchema = zod_1.z.enum(["EMAIL", "SMS"]);
exports.communicationTemplateIdSchema = zod_1.z.string().uuid();
exports.communicationTemplateStatusSchema = zod_1.z.enum(["ACTIVE", "ARCHIVED"]);
exports.communicationTemplateSchema = zod_1.z.object({
    id: exports.communicationTemplateIdSchema,
    businessId: zod_1.z.string().uuid(),
    name: zod_1.z.string().trim().min(1).max(120),
    channel: exports.communicationDeliveryChannelSchema,
    subject: zod_1.z.string().trim().min(1).max(240).nullable(),
    body: zod_1.z.string().trim().min(1).max(20_000),
    status: exports.communicationTemplateStatusSchema,
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    archivedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.communicationTemplateListQuerySchema = zod_1.z.object({
    channel: exports.communicationDeliveryChannelSchema.optional(),
    status: exports.communicationTemplateStatusSchema.optional(),
});
exports.communicationTemplateListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.communicationTemplateSchema),
    total: zod_1.z.number().int().nonnegative(),
});
const communicationTemplateContentSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(120),
    channel: exports.communicationDeliveryChannelSchema,
    subject: zod_1.z.string().trim().min(1).max(240).optional(),
    body: zod_1.z.string().trim().min(1).max(20_000),
})
    .superRefine((value, context) => {
    if (value.channel === "EMAIL" && !value.subject) {
        context.addIssue({
            code: "custom",
            path: ["subject"],
            message: "Email templates require a subject.",
        });
    }
    if (value.channel === "SMS" && value.subject) {
        context.addIssue({
            code: "custom",
            path: ["subject"],
            message: "SMS templates cannot have a subject.",
        });
    }
});
exports.createCommunicationTemplateRequestSchema = communicationTemplateContentSchema;
exports.updateCommunicationTemplateRequestSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(120).optional(),
    subject: zod_1.z.string().trim().min(1).max(240).nullable().optional(),
    body: zod_1.z.string().trim().min(1).max(20_000).optional(),
})
    .refine((value) => Object.values(value).some((item) => item !== undefined), {
    message: "At least one template field is required.",
});
exports.communicationDeliveryAttemptSchema = zod_1.z.object({
    attemptNumber: zod_1.z.number().int().positive(),
    outcome: zod_1.z.enum(["SUCCEEDED", "FAILED"]),
    safeError: zod_1.z.string().nullable(),
    startedAt: zod_1.z.string().datetime(),
    completedAt: zod_1.z.string().datetime(),
});
exports.communicationDeliverySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    purpose: exports.notificationDeliveryPurposeSchema,
    aggregateType: zod_1.z.string().min(1).max(80),
    aggregateId: zod_1.z.string().min(1).max(255),
    channel: exports.communicationDeliveryChannelSchema,
    recipient: zod_1.z.string().trim().min(1).max(320),
    status: exports.notificationDeliveryStatusSchema,
    requestedAt: zod_1.z.string().datetime(),
    sentAt: zod_1.z.string().datetime().nullable(),
    deliveredAt: zod_1.z.string().datetime().nullable(),
    delayedAt: zod_1.z.string().datetime().nullable(),
    bouncedAt: zod_1.z.string().datetime().nullable(),
    complainedAt: zod_1.z.string().datetime().nullable(),
    failedAt: zod_1.z.string().datetime().nullable(),
    lastSafeError: zod_1.z.string().nullable(),
    attempts: zod_1.z.array(exports.communicationDeliveryAttemptSchema),
});
exports.communicationDeliveryListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.communicationDeliverySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.communicationDeliveryQuerySchema = pagination_1.paginationQuerySchema.extend({
    channel: exports.communicationDeliveryChannelSchema.optional(),
    purpose: exports.notificationDeliveryPurposeSchema.optional(),
    status: exports.notificationDeliveryStatusSchema.optional(),
    aggregateType: zod_1.z.string().trim().min(1).max(80).optional(),
    aggregateId: zod_1.z.string().trim().min(1).max(255).optional(),
});
exports.communicationDeliveryCountsSchema = zod_1.z.object({
    pending: zod_1.z.number().int().nonnegative(),
    sent: zod_1.z.number().int().nonnegative(),
    delivered: zod_1.z.number().int().nonnegative(),
    attention: zod_1.z.number().int().nonnegative(),
});
exports.businessSmsSettingsSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    provider: exports.smsProviderModeSchema,
    configured: zod_1.z.boolean(),
    production: zod_1.z.boolean(),
    phoneNumber: zod_1.z.string().nullable(),
    registrationStatus: exports.smsRegistrationStatusSchema,
    inboundWebhookReady: zod_1.z.boolean(),
    statusWebhookReady: zod_1.z.boolean(),
});
exports.updateBusinessSmsSettingsRequestSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
});
exports.communicationSettingsResponseSchema = zod_1.z.object({
    provider: exports.emailProviderModeSchema,
    configured: zod_1.z.boolean(),
    production: zod_1.z.boolean(),
    senderAddress: zod_1.z.string().email().nullable(),
    senderName: zod_1.z.string().nullable(),
    replyTo: zod_1.z.string().email().nullable(),
    recentCounts: exports.communicationDeliveryCountsSchema,
    recentDeliveries: zod_1.z.array(exports.communicationDeliverySchema),
    sms: exports.businessSmsSettingsSchema.extend({
        webhookUrl: zod_1.z.string().url().nullable(),
        recentCounts: exports.communicationDeliveryCountsSchema,
    }),
});
exports.smsProviderWebhookAcknowledgementSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    duplicate: zod_1.z.boolean(),
    matched: zod_1.z.boolean(),
});
exports.createInvoiceDeliveryRequestSchema = zod_1.z.object({
    idempotencyKey: zod_1.z.string().uuid(),
});
exports.invoiceDeliverySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    versionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    recipient: zod_1.z.string().email(),
    status: exports.notificationDeliveryStatusSchema,
    requestedAt: zod_1.z.string().datetime(),
    sentAt: zod_1.z.string().datetime().nullable(),
    deliveredAt: zod_1.z.string().datetime().nullable(),
    delayedAt: zod_1.z.string().datetime().nullable(),
    bouncedAt: zod_1.z.string().datetime().nullable(),
    complainedAt: zod_1.z.string().datetime().nullable(),
    failedAt: zod_1.z.string().datetime().nullable(),
    failureReason: zod_1.z.string().nullable(),
});
exports.invoiceDeliveryListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.invoiceDeliverySchema),
});
exports.emailProviderWebhookAcknowledgementSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    duplicate: zod_1.z.boolean(),
    matched: zod_1.z.boolean(),
});
//# sourceMappingURL=communication.js.map